export default "__VITE_ASSET__8fp0JnbF__"